import {
  Outlet,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { ErrorPage } from './ErrorPage';
import AuthenticatedApp from '@/AuthenticatedApp';
import ElectrolyteRoutes from './routes';
import UnauthenticatedRoutes from './UnauthenticatedRoutes';
import { GlobalDialogs } from '@/components/GlobalDialogs';
import { EmbeddedThemeProvider } from '@/components/Embedded/EmbeddedThemeProvider';
import { useIsEmbedded } from '@/hooks/useIsEmbedded';

/**
 * The outermost page of all pages/routes, so we can place the "GlobalDialogs" as a sibling of
 * all other pages/routes.
 *
 * It also applies the EmbeddedThemeProvider when a route is embed. This theme provider needs to be
 * placed inside the router provider, so here is the topmost point that's already inside the router.
 */
const OutermostPageWrapper = () => {
  const { isEmbeddedRoute } = useIsEmbedded();

  const wrapper = (
    <>
      <GlobalDialogs />
      <Outlet />
    </>
  );

  if (isEmbeddedRoute) {
    return <EmbeddedThemeProvider>{wrapper}</EmbeddedThemeProvider>;
  }

  return wrapper;
};

export const authenticatedRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<OutermostPageWrapper />} errorElement={<ErrorPage />}>
      <Route element={<AuthenticatedApp />}>
        <Route path="/*" element={<ElectrolyteRoutes />} />
      </Route>
    </Route>
  )
);

export const unauthenticatedRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<OutermostPageWrapper />} errorElement={<ErrorPage />}>
      <Route path="/*" element={<UnauthenticatedRoutes />} />
    </Route>
  )
);
